import React, { createRef } from 'react';
import { withStyles } from '@material-ui/styles';
import styles from '../styles';
import Dropzone from 'react-dropzone';

const File = withStyles(styles)(({ classes, i, treeTrace, error, data, onChange, value, mode }) => {
  const { field, label, direction, disabledOnEdit, validate, fileCountLimit, acceptedFiles } = i;
  const dropzoneRef = createRef();

  return (
    <Dropzone
      ref={dropzoneRef}
      accept={acceptedFiles}
      onDrop={files =>
        onChange(
          field,
          files
            .slice(0, fileCountLimit || undefined) // making it undefined will result in default behavior using `slice` with only one parameter
            .map(f =>
              Object.assign({}, f, {
                file: f,
                preview: URL.createObjectURL(f),
              }),
            ),

          treeTrace,
        )
      }
    >
      {({ getRootProps, getInputProps, acceptedFiles }) => {
        return (
          <div className={classes.dropzoneContainer}>
            <div {...getRootProps({ className: classes.dropzone })}>
              <input {...getInputProps()} />
              <div>
                <p>
                  {label}: {!!error && error}
                </p>
                <p>Drag 'n' drop some files here, or click to select files</p>
              </div>
            </div>
            <aside>
              {data && data[i.field] ? (
                Array.isArray(data[field]) ? (
                  data[field].map(file => {
                    if (['.jpg', '.jpeg', '.png'].some(ext => file.path.includes(ext))) {
                      return <img key={file} src={file.preview} className={classes.dropzoneImage} />;
                    }

                    return (
                      <div>
                        {file.path} - {file.size} bytes
                      </div>
                    );
                  })
                ) : (
                  <img key={data[field]} src={data[field].preview} className={classes.dropzoneImage} />
                )
              ) : (
                <div></div>
              )}
            </aside>
          </div>
        );
      }}
    </Dropzone>
  );
});

export default File;
